import type React from 'react';
import type { SizeConfigType, VariantLoadingSize } from './const';
import { ANIMATION_DELAYS, SIZE_CONFIG } from './const';

// 屏幕阅读器辅助文本
export const SR_LOADING_TEXT = 'Loading';

// 加载点符号（视觉元素）
export const LOADING_DOT = '.';

// 终端提示符
export const TERMINAL_PROMPT = '>';

/**
 * 获取尺寸类名
 */
export function getSizeClass(size: VariantLoadingSize): string {
  return `wg-variant-loading--size-${size}`;
}

/**
 * 获取指定尺寸的配置值
 */
export function getSizeValue(
  size: VariantLoadingSize,
  key: keyof SizeConfigType[VariantLoadingSize],
): number {
  return SIZE_CONFIG[size][key as keyof SizeConfigType[VariantLoadingSize]];
}

/**
 * 计算动画延迟时间
 */
export function getAnimationDelay(index: number, type: keyof typeof ANIMATION_DELAYS): number {
  return index * ANIMATION_DELAYS[type];
}

/**
 * 生成数组（用于渲染多个元素）
 */
export function generateArray(count: number): number[] {
  return Array.from({ length: count }, (_, i) => i);
}

/**
 * 计算经典 Loading 的条样式
 */
export function getClassicBarStyle(size: VariantLoadingSize, index: number): React.CSSProperties {
  const isSmall = size === 'sm';
  const isLarge = size === 'lg';

  const marginLeft = isSmall ? -0.75 : isLarge ? -1.25 : -1;
  const transformOrigin = `${isSmall ? 0.75 : isLarge ? 1.25 : 1}px ${
    isSmall ? 10 : isLarge ? 14 : 12
  }px`;

  return {
    transform: `rotate(${index * 30}deg)`,
    marginLeft: `${marginLeft}px`,
    transformOrigin,
    animationDelay: `${index * 0.1}s`,
  };
}
